import React from "react"
import { Box, Text, Flex, Image, Grid } from "theme-ui"
import { InboundLink } from "./link"
import { getPagePath, getArticlePath, getProductPath } from "../utils/path"
import { LanguageSwitcherContext } from "../context/languageSwitcherContext"
import { i18nContext } from "../context/i18nContext"
import ArrowRight from "../images/list-arrow-violet.svg"

const CaseCollection = ({ record }) => {
  console.log(record)
  const locale = React.useContext(LanguageSwitcherContext).activeLocale
  return (
    <i18nContext.Consumer>
      {t => (
        <Flex
          sx={{
            flexDirection: "column",
            a: {
              textDecoration: "none",
            },
          }}
        >
          {record.cases.map(caseItem => {
            const { title, subtitle, image } = caseItem
            const isExternalCase = caseItem.model.apiKey === "external_case"
            const isInternalCase = caseItem.model.apiKey === "internal_case"

            // External case: link field uses internal/external link union
            const link = isExternalCase ? caseItem.link : null
            const isExternalLink = link?.model?.apiKey === "external_link"
            const isInternalLink = link?.model?.apiKey === "internal_link"

            const getLinkPath = () => {
              if (isInternalCase && caseItem.case) {
                return getProductPath(caseItem.case, locale)
              }
              if (isExternalCase && isInternalLink && link?.link) {
                const linkedItem = link.link
                if (linkedItem.root !== undefined) {
                  return getPagePath(linkedItem, locale)
                }
                if (linkedItem.slug !== undefined) {
                  return getArticlePath(linkedItem, locale)
                }
              }
              return null
            }

            const hoverHandlers = {
              onMouseEnter: e => {
                const arrow = e.currentTarget.querySelector(
                  "img[alt='arrow-right']"
                )
                const text =
                  e.currentTarget.querySelector(".read-more-text")
                if (arrow)
                  arrow.style.transform = "scaleX(1.5) translateX(10px)"
                if (text) text.style.opacity = "0"
              },
              onMouseLeave: e => {
                const arrow = e.currentTarget.querySelector(
                  "img[alt='arrow-right']"
                )
                const text =
                  e.currentTarget.querySelector(".read-more-text")
                if (arrow) arrow.style.transform = "scaleX(1) translateX(0)"
                if (text) text.style.opacity = "1"
              },
            }

            const content = (
              <Grid
                columns={[1, "1fr 1fr"]}
                gap={["40px", "40px"]}
                sx={{
                  borderTop: "1px solid",
                  borderColor: "primary",
                  py: "30px",
                }}
              >
                {image && (
                  <Image
                    sx={{
                      maxHeight: "200px",
                      width: "100%",
                      borderRadius: "20px",
                      overflow: "hidden",
                    }}
                    src={image?.url}
                    alt={title}
                  />
                )}

                <Box>
                  <Text
                    sx={{
                      fontSize: "16px",
                      color: "primary",
                      textTransform: "uppercase",
                      lineHeight: "1.5",
                      fontWeight: 500,
                    }}
                  >
                    {title}
                  </Text>
                  <Box
                    sx={{
                      p: {
                        fontSize: "16px",
                        color: "dark",
                        fontWeight: 400,
                        strong: {
                          fontWeight: 700,
                        },
                      },
                    }}
                    dangerouslySetInnerHTML={{
                      __html: subtitle,
                    }}
                  />
                  <Flex
                    sx={{
                      alignItems: "center",
                      gap: "10px",
                      transition: "all 0.3s ease",
                      overflow: "hidden",
                    }}
                  >
                    <Image
                      src={ArrowRight}
                      alt="arrow-right"
                      sx={{
                        transition: "transform 0.3s ease",
                        transformOrigin: "center",
                      }}
                    />
                    <Text
                      className="read-more-text"
                      sx={{
                        textTransform: "uppercase",
                        fontSize: "16px",
                        fontWeight: 500,
                        color: "primary",
                        transition: "opacity 0.3s ease",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {link?.anchor || t.readMore}
                    </Text>
                  </Flex>
                </Box>
              </Grid>
            )

            // External case with external link (opens in new tab)
            if (isExternalCase && isExternalLink && link.url) {
              return (
                <a
                  key={caseItem.id}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    textDecoration: "none",
                    display: "block",
                    transition: "all 0.3s ease",
                  }}
                  {...hoverHandlers}
                >
                  {content}
                </a>
              )
            }

            // Internal case or external case with internal link
            const internalPath = getLinkPath()
            if (internalPath) {
              return (
                <InboundLink
                  key={caseItem.id}
                  to={internalPath}
                  sx={{
                    display: "block",
                    transition: "all 0.3s ease",
                    "&:hover": {
                      "img[alt='arrow-right']": {
                        transform: "scaleX(1.5) translateX(10px)",
                      },
                      ".read-more-text": {
                        opacity: 0,
                      },
                    },
                  }}
                >
                  {content}
                </InboundLink>
              )
            }

            return null
          })}
        </Flex>
      )}
    </i18nContext.Consumer>
  )
}

export default CaseCollection
